import { VendorCategoryCreatePage } from '@/features/vendor-category/pages/VendorCategoryCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/vendor-category/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["vendor_category.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: VendorCategoryCreatePage,
})
